import React from "react";
import { Button, Typography, useMediaQuery } from "@material-ui/core";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import EventNoteIcon from "@material-ui/icons/EventNote";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { useHistory } from "react-router-dom";
import {
  FEATURE_FLAGS,
  featureKey,
  useDomainFeatures,
} from "../../context/DomainFeaturesContext";
import "./HeroSection.css";

const HERO_FEATURES = [
  {
    id: "curriculum",
    icon: MenuBookIcon,
    title: "Curriculum & progress",
    text: "Areas of Work, Activities, and Exercises with personalized next steps.",
  },
  {
    id: "planner",
    icon: EventNoteIcon,
    title: "Plans & planner",
    text: "Activity Planner plus ready-made lesson plans for every classroom.",
  },
  {
    id: "operations",
    icon: AssignmentTurnedInIcon,
    title: "School operations",
    text: "Attendance, admissions, and assignments in one calm workflow.",
  },
  {
    id: "parents",
    icon: PeopleOutlineIcon,
    title: "Parent engagement",
    text: "Real-time updates, observations, and mobile apps for families.",
  },
];

const SYSTEM_FEATURE_FLAG_KEYS = new Set(
  Object.values(FEATURE_FLAGS).map((name) => featureKey(name)),
);

const isSystemFeatureFlag = (name) => {
  const key = featureKey(name);
  const raw = String(name || "").trim().toLowerCase();
  if (!key) return true;
  if (raw.startsWith("disable_")) return true;
  if (SYSTEM_FEATURE_FLAG_KEYS.has(key)) return true;
  if (key.includes("pin") && key.includes("zip")) return true;
  if (key === "state" || (key.includes("state") && key.includes("us"))) return true;
  if (key.includes("dpa")) return true;
  if (key.includes("teacher") && key.includes("staff")) return true;
  if (
    (key.includes("disable") || key.includes("remove") || key.includes("hide")) &&
    (key.includes("circul") ||
      key.includes("curricul") ||
      key.includes("cirrcul") ||
      key.includes("circrul"))
  ) {
    return true;
  }
  return false;
};

const HeroSection = () => {
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width:600px)");
  const demoVideo = "/images/home.mp4?v=20260330_1";
  const { features: domainFeatures, found, loading } = useDomainFeatures();

  // Marketing cards only — skip Origin Master system flags (e.g. disable_indian_circulum).
  const marketingFeatures = (domainFeatures || []).filter(
    (f) => f?.name && !isSystemFeatureFlag(f.name),
  );

  const displayFeatures = HERO_FEATURES;

  return (
    <>
    <section className="hero-section">
      <div className="hero-section__inner">
        <div className="hero-layout">
          <div className="hero-copy">
            <span className="hero-eyebrow">
              <VerifiedUserIcon className="hero-eyebrow__icon" />
              Built exclusively for Montessori schools
            </span>

            <Typography
              component="h1"
              className="hero-title"
              style={{ fontSize: isMobile ? "1.85rem" : undefined }}
            >
              Hands-on learning.
              <span className="hero-title__accent"> Simplified operations.</span>
            </Typography>

            <Typography className="hero-lead">
              Montestory aligns with Montessori philosophy—helping teachers plan,
              track, and share each child&apos;s journey without the admin overload.
            </Typography>

            <div className="hero-features">
              {displayFeatures.map(({ id, icon: Icon, title, text }) => (
                <article key={id} className="hero-feature">
                  <span className="hero-feature__icon" aria-hidden>
                    <Icon />
                  </span>
                  <div className="hero-feature__body">
                    <h3 className="hero-feature__title">{title}</h3>
                    {text ? <p className="hero-feature__text">{text}</p> : null}
                  </div>
                </article>
              ))}
            </div>

            <div className="hero-cta">
              <Button
                variant="contained"
                className="hero-cta__primary"
                endIcon={<ArrowForwardIcon />}
                onClick={() => history.push("/montessori/schoolregistration")}
                style={{ backgroundColor: "rgb(15 59 98)", color: "white" }}
              >
                Start your free trial
              </Button>
              <Button
                component="a"
                href={demoVideo}
                target="_blank"
                rel="noopener noreferrer"
                variant="outlined"
                className="hero-cta__secondary"
                startIcon={<PlayArrowIcon />}
              >
                Watch demo
              </Button>
            </div>
          </div>

          <div className="hero-visual">
            <div className="hero-visual__frame">
              <img
                src="/images/hero.png"
                alt="Children learning with Montessori materials"
                className="hero-visual__image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* <aside className="hero-imf-strip" aria-label="Indian Montessori Foundation partnership">
      <div className="hero-imf-strip__inner">
        <img
          src="/images/imf-friend.png"
          alt="Indian Montessori Foundation"
          className="hero-imf-strip__logo"
        />
        <div className="hero-imf-strip__text">
          <p className="hero-imf-strip__title">Friend of IMF</p>
          <p className="hero-imf-strip__subtitle">Indian Montessori Foundation</p>
        </div>
      </div>
    </aside> */}
  </>
  );
};

export default HeroSection;
